function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { columnPropTypes } from './helpers';

/**
 * A component used to pass column information to a {@link Table} or {@link SortableTable}.
 *
 * @name TableColumn
 * @type Function
 * @param {String} name - The key of the value to display in the column from each data object
 * @param {String} [label] - The text that will be displayed in the column header. Defaults to `name`.
 * @param {Function} [sortFunc] - The function that will be used to sort the table data when the column is selected
 * @param {Function} [component] - A custom cell component for the column. Will be passed the `key`, `name`, `value` and `data` for the row.
 * @param {Function} [headerComponent] - A custom header component for the column. Will be passed the configuration of the column, as well as the current `sortPath` / `ascending` and an `onClick` handler. `onClick` must be appended to allow for sorting functionality.
 * @param {Function} [onClick] - A function that will be called `onClick` on every cell in the column.
 * @param {Function} [format] - A function that formats the value displayed in each cell in the column
 * @param {Boolean} [disabled] - A flag that disables sorting for the column
 * @param {String} [placeholder] - A string that will be displayed if the value of the cell is `undefined` or `null`
 * @param{Function} [valueGetter] - A function that will return a cell's value derived from each data object. Will be passed the `data` for the row.
 * @example
 *
 * function PersonTable ({ people }) {
 *   return (
 *     <SortableTable data={ people } initialColumn="name">
 *       <TableColumn name="name" />
 *       <TableColumn name="age" label="Years alive" disabled />
 *       <TableColumn name="status" component={ StatusCell } />
 *     </SortableTable>
 *   )
 * }
 *
 *@example
 *
 * function CustomHeader({ column: { name }, onClick }) {
 *   return (
 *     <th onClick={onClick}>{name.toUpperCase() + '!'}</th>
 *   )
 * }
 *
 */

var propTypes = _objectSpread({}, columnPropTypes);

// This component isn't rendered - it's simply used as a way to
// pass column information to SortableTable.

function TableColumn() {
  return null;
}
TableColumn.propTypes = propTypes;
export default TableColumn;